import { Box } from '@chakra-ui/react';
import { getAddMore } from './utils';

const DoneButton = ({ props }) => {
  return (
    <Box marginTop='1rem' marginBottom='1rem'>
      {getAddMore(props)}
    </Box>
  );
};
export default DoneButton;
